import React, { useEffect } from 'react';
import { withStyles, Theme, createStyles, makeStyles } from '@material-ui/core/styles';

import SplashTables from '../../assets/splashTables.png'
import { Container, Button, Paper, Input, Typography, Grid, InputAdornment, FormControlLabel, Checkbox, FormControl, FormGroup, IconButton } from '@material-ui/core';
import moment from 'moment'
import AttachFile from '@material-ui/icons/AttachFile';
import Delete from '@material-ui/icons/Delete';
import MomentUtils from '@date-io/moment';
import { createTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import BackIcon from '@material-ui/icons/ArrowBackIos';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import {
    MuiPickersUtilsProvider, DatePicker,
} from '@material-ui/pickers';

import CardActions from '@material-ui/core/CardActions';
import Parse from 'parse';

import firebase from 'firebase/compat/app'
import 'firebase/compat/storage';

import orange from '@material-ui/core/colors/orange';
import blue from '@material-ui/core/colors/blue';
const defaultMaterialTheme = createTheme({
    palette: {
        primary: blue,
    },
});

const ASSETS_MICROSERVICE_URL = 'http://157.230.55.48:60300'

// import {
//     MuiPickersUtilsProvider,
//     KeyboardTimePicker,
//     KeyboardDatePicker,
// } from '@material-ui/pickers';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            '& > *': {
                margin: theme.spacing(1),
            },
        },
        input: {
            display: 'none',
        },
        header: {
            backgroundColor: theme.palette.nav.app,
            [theme.breakpoints.up('sm')]: {
                paddingRight: 104,
                paddingLeft: 104
            },
            [theme.breakpoints.down('sm')]: {
                paddingRight: 48,
                paddingLeft: 48
            },
        },
        headerText: {
            color: '#000',
            fontSize: 28,
            marginTop: 10,
            marginBottom: 10
        },
        buttonColor: {
            backgroundColor: theme.palette.nav.actions,
            color: theme.palette.nav.text
        }
    }),


);
const useStyles2 = makeStyles({
    root: {
        minWidth: 275,
        width: "100%"
    },

});

const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
        head: {
            // backgroundColor: theme.palette.common.black,
            // color: theme.palette.common.white,
        },
        body: {
            fontSize: 14,
        },
    }),
)(TableCell);

const StyledTableRow = withStyles((theme: Theme) =>
    createStyles({
        root: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.action.hover,
            },
        },
    }),
)(TableRow);

// const columns = [
//     { id: 'code', label: 'Código', maxWidth: 70 },
//     { id: 'date', label: 'Fecha', maxWidth: 70 },
//     { id: 'hour', label: 'Hora', maxWidth: 50, },
//     { id: 'items', label: 'Monto', maxWidth: 50, align: 'right', },
//     { id: 'items', label: 'Comprobantes', maxWidth: 50, align: 'right', },
//     { id: 'status', label: 'Adjuntos', minWidth: 170, align: 'right' }
// ]

const columnsDetail = [
    { id: 'code', label: 'Código', maxWidth: 70 },
    { id: 'date', label: 'Fecha', maxWidth: 70 },
    { id: 'hour', label: 'Hora', maxWidth: 50, },
    { id: 'amount', label: 'Monto', maxWidth: 50, align: 'right' },
    { id: 'comprobantes', label: 'Comprobantes', maxWidth: 50, align: 'right' },
    { id: 'adjuntos', label: 'Adjuntos', minWidth: 170, align: 'right', }
]

function PaymentNotice(props) {

    const classes = useStyles();
    const classes2 = useStyles2();

    const [selectedDate, setSelectedDate] = React.useState(new Date());
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [amountToPay, setAmountToPay] = React.useState(null);
    const [observation, setObservation] = React.useState(null);
    // const [amountRemaining, setAmountRemaining] = React.useState(0);
    // const [amountTotal, setAmountTotal] = React.useState(0);
    // const [selectedCCA, setSelectedCCA] = React.useState([]);
    const [selectedURL, setSelectedURL] = React.useState(null);
    // const [selectedAll, setSelectedAll] = React.useState(false);
    const [rows, setRows] = React.useState([]);
    const [pymrows, setpymRows] = React.useState([]);
    const user = JSON.parse(localStorage.user)

    const handleDateChange = (date: Date | null) => {
        setSelectedDate(date);
    };

    const createData = (code, date, hour, amount, comprobantes, adjuntos, data) => {
        return { code, date, hour, amount, comprobantes, adjuntos, data };
    }

    function getPaymentNotice() {
        const query = new Parse.Query('PaymentNotice');
        query.equalTo('envId', localStorage.env);
        query.equalTo('c', localStorage.client);
        query.find().then((res) => {
            let arr = [];
            for (var i in res) {
                let elem = res[i].attributes;
                let elemn = createData((res[i].id),
                    moment(elem.t).format('DD/MM/YYYY'),
                    moment(elem.t).format('hh:mm:ss'),
                    '$ ' + elem.tt,
                    elem.impdoc ? elem.impdoc.length : 0,
                    elem.ia ? elem.ia.length : 0,
                    elem
                );
                arr.push(elemn);
            }
            setpymRows(arr);
        });
    }

    useEffect(() => {

        getPaymentNotice()

        if (localStorage.historialCobranzas.length > 0) {
            setRows(JSON.parse(localStorage.historialCobranzas))
        }

    }, [])

    const handleFileChange = (x) => {
        var reader = new FileReader();
        reader.readAsDataURL(x.target.files[0]);
        reader.onload = function () {
            // cb(reader.result)
            setSelectedURL(reader.result)
        };
        setSelectedFile(x.target.files[0]);
    };

    const handleChageTotal = (x) => {
        setAmountToPay(x.target.value);
        // setAmountRemaining(+amountTotal - (+x.target.value))
    };

    // const handleChangeCCA = (event, x) => {

    //     setSelectedCCA({ ...selectedCCA, [event.target.name]: event.target.checked });
    //     var total = amountTotal;
    //     if (event.target.checked) {
    //         total += +x.pending.replace('$', '').replace(' ', '').replace(',', '')
    //     }
    //     else {
    //         total -= +x.pending.replace('$', '').replace(' ', '').replace(',', '')
    //     }

    //     setAmountTotal(total)
    //     setAmountRemaining(total - (+amountToPay))

    // }

    const [actualView, setActualView] = React.useState(1)

    const saveImgDitalOcean = async (archivo, fileName) => {

        const _data = new FormData();
        _data.append('my-file', archivo, fileName);

        const config = {
            method: 'POST',
            body: _data
        };

        const resultURL = await fetch(`${ASSETS_MICROSERVICE_URL}/file/PaymentNotice/${window.localStorage.getItem('envId')}`, config); // MICROSERVICIO 
        return resultURL.json();

    }

    const savePamymentNotice = async () => {
        let urls = []
        let selected = []

        if (selectedURL) {
            if (selectedFile) {
                let resURL = await saveImgDitalOcean(selectedFile, `p_${Date.now()}${localStorage.client}.jpg`)
                if (resURL && Object.values(resURL)[0] && Object.values(resURL)[0].rURL) urls.push(Object.values(resURL)[0].rURL)
            } else {
                urls.push(selectedURL)
            }
        }

        let pyn = Parse.Object.extend("PaymentNotice");
        let pn = new pyn();
        // if ((urls && selectedFile) && urls.length === selectedFile.length) {
        pn.set('ia', urls.length > 0 ? urls : null)

        // for (var i in selectedCCA) {
        //     if (selectedCCA[i]) {
        //         selected.push(i)

        //     }
        // }
        // }
        pn.set('comment', observation)
        pn.set('impdoc', selected.length > 0 ? selected : null)
        pn.set('c', localStorage.client)
        pn.set('t', new Date(selectedDate).getTime())
        pn.set('tt', +amountToPay)
        pn.set('envId', localStorage.env)
        pn.save().then((x) => {
            // fetch('http://164.90.134.205:61400/sendPaymentNotice?data=' + JSON.stringify(x.attributes), {
            //     method: 'POST',
            // }).then((response) => response.json()).then((responseJson) => {
            // }).catch((e) => {
            // })
            setActualView(1)
            getPaymentNotice();

        })
    }

    return (
        <div>

            <div className={classes.header}>
                {actualView === 1 ?
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 115 }}>
                        <div style={{ zIndex: 1 }}>
                            <p className={classes.headerText}>Aviso de pago</p>
                        </div>
                        <Button disabled={user.k == "" || user.k == undefined || user.k == null ? true : false} onClick={() => { setActualView(2) }}
                            className={classes.buttonColor}
                            style={{ height: 40, paddingLeft: 20, paddingRight: 20, fontWeight: 'bold' }}
                            variant="contained" size="small" color="secondary"
                        //   className={classes.submit}
                        >
                            Nuevo aviso de pago
                        </Button>
                    </div>
                    :
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 115 }}>
                        <div style={{ zIndex: 1 }}>
                            <p className={classes.headerText}>
                                <IconButton onClick={() => { setActualView(1) }} aria-label="delete" size="small">
                                    <BackIcon style={{ fontSize: 24 }} />
                                </IconButton>Nuevo aviso de pago</p>
                        </div>
                    </div>
                }
            </div>
            <Container maxWidth="lg" style={{ marginTop: 50 }}>
                {
                    actualView === 1 ?

                        <Paper className={classes2.root}>
                            <TableContainer >
                                <Table stickyHeader size="small" aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {columnsDetail.map((column) => (
                                                <TableCell
                                                    key={column.id}

                                                    align={column.align}
                                                    style={{ minWidth: column.minWidth }}
                                                >
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {pymrows.map((rowData, key) => {
                                            const row = rowData
                                            return (
                                                <StyledTableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                                    {columnsDetail.map((column) => {
                                                        const value = row[column.id];


                                                        return (
                                                            <StyledTableCell key={column.id} align={column.align}>
                                                                {column.format && typeof value === 'number' ? column.format(value) : value}
                                                            </StyledTableCell>
                                                        );
                                                    })}
                                                </StyledTableRow>
                                            );
                                        })}
                                        {pymrows.length > 0 ?
                                            null
                                            :
                                            <Typography variant="subtitle2" gutterBottom>No ha enviado ningun aviso de pago</Typography>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        :
                        <Paper spacing={2}>
                            <Grid container style={{ padding: 15 }}>
                                <Grid style={{ marginBottom: 10 }} item xs={12}>
                                    <Typography variant="subtitle1" gutterBottom>Fecha</Typography>
                                    <Typography variant={"body2"}>{moment().format('DD/MM/YYYY')}</Typography>
                                </Grid>
                                <Grid style={{ marginBottom: 10 }} item xs={12}>
                                    <Typography variant="subtitle1" gutterBottom>Fecha de pago</Typography>
                                    <ThemeProvider theme={defaultMaterialTheme}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <DatePicker
                                                autoOk
                                                fullWidth
                                                label="Seleccionar"
                                                disableFuture
                                                format="DD/MM/YYYY"
                                                value={selectedDate}
                                                onChange={handleDateChange}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </ThemeProvider>
                                </Grid>
                                <Grid style={{ marginBottom: 10 }} item xs={12}>
                                    <Typography variant="subtitle1" gutterBottom>Comentario</Typography>
                                    <Input fullWidth placeholder="Escribir comentario" value={observation} onChange={(e) => setObservation(e.target.value)} inputProps={{ 'aria-label': 'description' }} />
                                </Grid>
                                <Grid style={{ marginBottom: 10 }} item xs={12}>
                                    <Typography variant="subtitle1" gutterBottom>Importe total</Typography>
                                    <Input
                                        startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                        type="number"
                                        fullWidth value={amountToPay} onChange={handleChageTotal} placeholder="0" inputProps={{ 'aria-label': 'description' }} />
                                </Grid>
                                {/* <Grid style={{ marginBottom: 10 }} item xs={12}>
                                    <Typography variant="subtitle1" gutterBottom>Importe restante</Typography>
                                    <Input
                                        startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                        disabled fullWidth value={parseFloat(amountRemaining).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} placeholder="Placeholder" inputProps={{ 'aria-label': 'description' }} />
                                </Grid> */}
                                {/* <Grid style={{ marginBottom: 10 }} item xs={12}>
                                    <Typography variant="subtitle1" gutterBottom>Total Comprobantes</Typography>
                                    <Input
                                        startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                        disabled fullWidth value={parseFloat(amountTotal).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} placeholder="Placeholder" inputProps={{ 'aria-label': 'description' }} />
                                </Grid> */}
                                {/* <Grid style={{ marginBottom: 10 }} item xs={12}>
                                    <Typography variant="h6" gutterBottom>Comprobantes imputados</Typography>
                                    <FormControl component="fieldset">
                                        <FormGroup>
                                            {rows.map((a, b) => (
                                                <div>
                                                    <FormControlLabel
                                                        control={<Checkbox checked={selectedCCA[a.code]} pending={a.pending} onChange={(ev) => { handleChangeCCA(ev, a) }} name={a.code} />}
                                                        label={a.code + " (" + a.pending + ")"}
                                                    />
                                                </div>
                                            ))}
                                        </FormGroup >
                                    </FormControl>
                                </Grid> */}
                                <Grid style={{ marginBottom: 10 }} item xs={12}>
                                    <Typography variant="h6" gutterBottom>Adjunte orden de pago, depósito bancario o retenciones en caso de corresponder</Typography>
                                    <input
                                        accept="image/*,.jpg, .png, .doc"
                                        className={classes.input}
                                        id="contained-button-file"
                                        //multiple
                                        type="file"
                                        onChange={handleFileChange}
                                    />
                                    <label htmlFor="contained-button-file">
                                        <Button color="primary" component="span" size={"small"} multiple startIcon={<AttachFile />}>
                                            Adjuntar archivo (opcional)
                                        </Button>
                                    </label>
                                    {/*  <Button color="primary" component="span" size={"small"} multiple startIcon={<AttachFile />}>
                                            Adjuntar archivos ( opcional)
                                    </Button> */}
                                    <div style={{ display: "flex", flexDirection: "row", }}>
                                        {selectedURL ?
                                            <Paper elevation={2} style={{ width: 110, height: 170, margin: 5, textAlign: "center", alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                                <img alt="" style={{ width: 100, height: 100, borderRadius: 5 }} src={selectedURL}></img>
                                                <CardActions disableSpacing>
                                                    <IconButton
                                                        onClick={() => {
                                                            setSelectedURL(null)
                                                            setSelectedFile(null)
                                                        }}
                                                        aria-label="Borrar"
                                                    >
                                                        <Delete />
                                                    </IconButton>
                                                </CardActions>
                                            </Paper>
                                            : null}


                                    </div>
                                </Grid>
                                <Grid item style={{ textAlign: "end" }} xs={12}>
                                    <Button variant="contained" style={{ borderRadius: 30 }} onClick={savePamymentNotice} color="secondary" component="span" >
                                        Enviar
                                    </Button>
                                </Grid>
                            </Grid>
                        </Paper>
                }
            </Container>
        </div >
    )
}
export default PaymentNotice